import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@core/services/auth/auth.service';
import { NotificationService } from '@core/services/notification/notification.service';
import { environment } from '@environments/environment';
import { CUSTOM_ERROR_MESSAGE, SILENT_EROROR } from '@shared/models';
import { catchError, throwError } from 'rxjs';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const authService = inject(AuthService);
  const notificationService = inject(NotificationService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (environment.enableDebugLogging) {
        console.error('HTTP Error:', error);
      }

      //skip notification and redirection for silent errors
      if (req.context.get(SILENT_EROROR)) return throwError(() => error);

      const customMessage = req.context.get(CUSTOM_ERROR_MESSAGE);
      const message = customMessage || getErrorMessage(error);

      if (error.status === 401) {
        // Unauthorized - logout and redirect to login
        notificationService.error(message);
        authService.logout();
        router.navigate(['/login']);
      }

      if (error.status === 403) {
        // Forbidden - redirect to dashboard
        notificationService.error(message);
        router.navigate(['/dashboard']);
      }

      notificationService.error(message);

      return throwError(() => error);
    })
  );
};

function getErrorMessage(error: HttpErrorResponse): string {
  switch (error.status) {
    case 400: return 'Invalid request. Please check your input.';
    case 401: return 'You are not authorized. Please log in again.';
    case 403: return 'You do not have permission to perform this action.';
    case 404: return 'The requested resource was not found.';
    case 409: return 'A conflict occurred. Please refresh and try again.';
    case 500: return 'A server error occurred. Please try again later.';
    default: return 'An unexpected error occurred. Please try again.';
  }
}